module.exports = __webpack_public_path__ + "static/hrblock-screen-photo-c9cf8e8ef1e244dc7d31e64be4fc4ed8.png";